import React from 'react';

export default function NoLayout({ title, children }) {
    return (
        <div>
            <div>{children}</div>
        </div>
    );
}
